function H1(props) {
  const { children } = props;
  return (
    <h1 className="text-4xl font-bold">{children}</h1>
  );
}

export default H1;
